export default __webpack_public_path__ + "images/c2024ebf2c76ea5c499a65aedfa91628.png";